import Vue from 'vue'

export default {
  getDataForClients ({ commit }) {
    return Vue.axios.get(`/about/data-for-clients`)
    .then(({ data }) => commit('ADD_DATA_FOR_CLIENTS', data))
  },
  updateDataForClientsOrder ({ commit }, data) {
    return Vue.axios.put(`/about/data-for-clients/order`, { data })
  },
  addDataForClients ({ commit }, data) {
    commit('ADD_NEW_DATA_FOR_CLIENTS', data)
  },
  updateDataForClients ({ commit }, data) {
    commit('UPDATE_DATA_FOR_CLIENTS', data)
  },
  deleteDataForClients ({ commit }, id) {
    return Vue.axios.delete(`/about/data-for-clients/${id}`)
    .then(() => commit('DELETE_DATA_FOR_CLIENTS', id))
  },
  loadDataForClientsFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/data-for-clients/${id}/load-file`, formData)
    .then(({ data }) => commit('CHANGE_DATA_FOR_CLIENTS_FILE', data))
  },
  saveDataForClients ({ commit, dispatch }, data) {
    return Vue.axios.put(`/about/data-for-clients`, { data })
    .then(() => {
      if (data.newFile) {
        return dispatch('loadDataForClientsFile', { formData: data.newFile, id: data.id })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/dataForClients.js